module.exports = "https://cdn.hellotech.com/client-assets/WiFi_927e8c73f6bd5cabd702925c7560a039.png";